import { Banner } from '@components';
import type { DateTime } from 'luxon';
import { type FC, useContext } from 'react';

import { SlabContext } from '@core/context/SlabContext';
import { reminderTriggerHint } from '@core/utils/reminders';

export const ReminderTriggerHintBanner: FC<{ triggerDate: DateTime }> = ({ triggerDate }) => {
  const { timezone } = useContext(SlabContext).userInfo.tenant;
  const { isPast, message } = reminderTriggerHint(triggerDate, timezone);

  return <Banner severity={isPast ? 'warning' : 'info'}>{message}</Banner>;
};
